import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import { ShareButtons } from 'react-share'
import logo from '../../resources/img/logo-qobuz.png'

const { TwitterShareButton, FacebookShareButton } = ShareButtons

class HeaderMenu extends Component {

	render() {
		const { share } = this.props
		const { intl } = this.context
		const url = share.url
		const mail = {
			subject: share.type ? intl.formatMessage({ id: `share.mail.${share.type}.subject` }, share.subject) : '',
			body: share.type ? intl.formatMessage({ id: `share.mail.${share.type}.body` }, { ...share.body, url }) : ''
		}
		const twitter = {
			title: share.type ? intl.formatMessage({ id: `share.twitter.${share.type}` }, share.twitter) : '',
			via: 'qobuz'
		}
		return (
			<div className="header">
				<div className="container">
					<div className="row">
						<div className="col-xs-2 col-sm-4 col-md-6">
							<a href="https://www.qobuz.com/" className="qbz-logo"><img src={logo} height={33} width={80} alt="Qobuz" /></a>
						</div>
						<div className="col-xs-10 col-sm-8 col-md-6">
							<div className="social-link">
								<FacebookShareButton className="bt8 small pct pct-facebook" url={url} />
								<TwitterShareButton className="bt8 small pct pct-twitter" url={url} {...twitter} />
								<div>
									<a
										href={`mailto:?subject=${encodeURIComponent(mail.subject)}&body=${encodeURIComponent(mail.body)}`}
										className="bt8 small"
									>
										<span className="pct pct-email" />
									</a>
								</div>
							</div>
							<a href="http://www.qobuz.com/apps" target="_blank" className="bt8 qbz-app hidden-xs">
								{intl.formatMessage({ id: 'buttons.download' })}
							</a>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

HeaderMenu.propTypes = {}

HeaderMenu.contextTypes = {
	intl: intlShape
}

const mapStateToProps = state => ({
	share: state.share
})

export default connect(mapStateToProps)(HeaderMenu)



// WEBPACK FOOTER //
// ./src/components/header/HeaderMenu.js